import Vue from "vue";
import vueHeadful from "vue-headful";

Vue.component("vue-headful", vueHeadful);
